/**
 * Chrome timings live in tokens.css (--dur-*), so CSS and scripts can't drift apart: a
 * script reads the token here instead of keeping its own copy of the number.
 */

/** A `--dur-*` token in milliseconds ("160ms", "2.4s"), or `fallback` when it can't be read (tests, SSR). */
export function tokenMs(name: string, fallback: number): number {
	if (typeof document === 'undefined' || typeof getComputedStyle !== 'function') return fallback;
	const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
	const m = /^([\d.]+)(ms|s)$/.exec(raw);
	if (!m) return fallback;
	const n = Number(m[1]) * (m[2] === 's' ? 1000 : 1);
	return Number.isFinite(n) ? n : fallback;
}
